import { Calendar, calendarDetailed, CalendarEntities, calendarSchema } from '@app/pcs/models/calendar';
import { pairAgency } from '@dossier/models/pair-agency';
import { PathSectionsEntities, pathSectionWithBaseTrainParameters } from '@dossier/models/path-section';
import { processStrategyForParent } from '@dossier/models/schema-process-strategy';
import { SubPath, SubPathsEntities, subPathsSchema, SubPathWithBlocks } from '@dossier/models/sub-path';
import { gql } from 'apollo-angular';
import { schema } from 'normalizr';

export interface BasePathVariant<T> {
  id?: number;
  sortOrder?: number;
  pathVariantTitle?: string;
  calendar?: Calendar;
  warning?: string;
  generalWarning?: string;
  originWarning?: boolean;
  destinationWarning?: boolean;
  changed?: boolean;
  subPaths: T[];
  userVariant?: boolean;
  containsPap?: boolean;
  pathSectionsWithNegativeBorderTime?: number[];
}

export interface PathVariant extends BasePathVariant<SubPath> {
  subPaths: SubPath[];
}

export interface PathVariantWithSubPathWithBlocks extends BasePathVariant<SubPathWithBlocks> {
  subPaths: SubPathWithBlocks[];
}

export interface PathVariantEntity extends BasePathVariant<number> {
  subPaths: number[];
}

export interface PathVariantEntities {
  [key: number]: PathVariantEntity;
}

export interface NormalizedPathVariant {
  entities: {
    pathVariants: PathVariantEntities;
    subPaths: SubPathsEntities;
    pathElements?: PathSectionsEntities;
    calendar?: CalendarEntities;
  };
  result: number;
}

export const pathVariantSchema = new schema.Entity('pathVariants', {
  subPaths: [subPathsSchema],
  calendar: calendarSchema
}, {idAttribute: 'id', processStrategy: processStrategyForParent});

export const pathVariantListSchema = new schema.Array(pathVariantSchema);

export const pathVariant = gql`
    fragment pathVariant on PathVariant {
        id
        sortOrder
        pathVariantTitle
        pathSectionsWithNegativeBorderTime
        calendar {
            ...calendarDetailed
        }
        warning
        generalWarning
        originWarning
        destinationWarning
        changed
        subPaths {
            id
      sortOrder
      pathTitle
      responsiblePair {
        id
        sortOrder
        applicantAgency {
          ...pairAgency
        }
        imAgency {
          ...pairAgency
        }
      }
      pathElements {
        ...pathSectionWithBaseTrainParameters
      }
      tsiVariantId
    }
    userVariant
    containsPap
  }
  ${calendarDetailed}
  ${pairAgency}
  ${pathSectionWithBaseTrainParameters}
`;
